import { render, staticRenderFns } from "./SelectProvider.vue?vue&type=template&id=21a4e50c"
import script from "./SelectProvider.vue?vue&type=script&lang=js"
export * from "./SelectProvider.vue?vue&type=script&lang=js"
import style0 from "./SelectProvider.vue?vue&type=style&index=0&id=21a4e50c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports